module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Neunkirch-e6fcf251686f811961dc0a836e54dc7e.png";